import { render, staticRenderFns } from "./ContentWrapperBlock.vue?vue&type=template&id=312db9ba&scoped=true&"
import script from "./ContentWrapperBlock.vue?vue&type=script&lang=js&"
export * from "./ContentWrapperBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContentWrapperBlock.vue?vue&type=style&index=0&id=312db9ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312db9ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312db9ba')) {
      api.createRecord('312db9ba', component.options)
    } else {
      api.reload('312db9ba', component.options)
    }
    module.hot.accept("./ContentWrapperBlock.vue?vue&type=template&id=312db9ba&scoped=true&", function () {
      api.rerender('312db9ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/ContentWrapperBlock.vue"
export default component.exports